export default {
  language: 'en',
};
